import { render } from "./TrendingRestaurants.vue?vue&type=template&id=518e26e8&scoped=true"
import script from "./TrendingRestaurants.vue?vue&type=script&lang=js"
export * from "./TrendingRestaurants.vue?vue&type=script&lang=js"

import "./TrendingRestaurants.vue?vue&type=style&index=0&id=518e26e8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-518e26e8"]])

export default __exports__